export default {
  buildFullAccessString: (siteName: string | undefined): string =>
    `Full access to ${siteName} includes:`,
  bullets: {
    first: "Unlock Premium news from the largest network of experts.",
    second: "Say your piece in exclusive fan communities.",
    third: "Dominate with stats, athlete data, Rivals250 rankings, and more."
  },
  goBig: "Go Big. Get Premium.",
  logIn: "Log In",
  subscribe: "Subscribe to read more."
};
